import { ReactNode, useContext, useState } from 'react'
import { ImpersonationContext } from './definition'
import { getUserIdByEmail } from '../../lib/api/moduleManager/getUserId'
import { getImpersonationToken } from '../../lib/api/moduleManager/getImpersonationToken'
import { AuthContext } from '../AuthContext/definition'
import { SettingsContext } from '../SettingsContext/definition'

export const ImpersonationProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const { moduleManagerToken } = useContext(AuthContext)
  const { settings, updateLocation } = useContext(SettingsContext)

  const [impersonatedUser, setImpersonatedUser] = useState<string>(
    localStorage.getItem('impersonatedUser') ?? '',
  )

  const [impersonatedUserID, setImpersonatedUserID] = useState<string>(
    localStorage.getItem('impersonatedUserID') ?? '',
  )

  const [impersonatedUserToken, setImpersonatedUserToken] = useState<string>(
    localStorage.getItem('impersonatedUserToken') ?? '',
  )

  const [impersonatedUserOffice, setImpersonatedUserOffice] = useState<string>(
    localStorage.getItem('impersonatedUserOffice') ?? '',
  )

  const endImpersonation = function (): void {
    localStorage.setItem('impersonatedUser', '')
    localStorage.setItem('impersonatedUserToken', '')
    localStorage.setItem('impersonatedUserID', '')
    localStorage.setItem('impersonatedUserLocation', '')
    updateLocation(localStorage.getItem('settings.home_office') as string)

    setImpersonatedUserToken('')
    setImpersonatedUserID('')
    setImpersonatedUserOffice('')
  }

  const updateImpersonation = async function (email: string): Promise<void> {
    setImpersonatedUser(email)
    if (/[A-z.]*@turbodebt.com/.test(email)) {
      const impersonatedUserId = await getUserIdByEmail(
        moduleManagerToken,
        email,
      )

      setImpersonatedUserID(impersonatedUserId)

      const { token, office_location } = await getImpersonationToken(
        moduleManagerToken,
        impersonatedUserId,
      )

      setImpersonatedUserToken(token)
      updateLocation(office_location)
      setImpersonatedUserOffice(office_location)

      localStorage.setItem('impersonatedUser', email)
      localStorage.setItem('impersonatedUserToken', token)
      localStorage.setItem('impersonatedUserID', impersonatedUserId)
      localStorage.setItem('impersonatedUserLocation', office_location)
      console.log(settings)
    } else {
      endImpersonation()
    }
  }

  return (
    <ImpersonationContext.Provider
      value={{
        impersonatedUserEmail: impersonatedUser,
        impersonatedUserId: impersonatedUserID,
        impersonatedUserToken,
        imepersonatedUserOffice: impersonatedUserOffice,
        impersonateUser: updateImpersonation,
        endImpersonation,
      }}
    >
      {children}
    </ImpersonationContext.Provider>
  )
}
